import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { AlertService } from '../../_services/alert.service';

@Component({
  templateUrl: 'validation.component.html',
  styleUrls: ['./validation.component.css']
})
export class ValidationComponent implements OnInit, AfterViewInit {
  validationForm: FormGroup;
  loading = false;
  submitted = false;
  errorMessage = '';
  successMessage = '';
  user = {};
  users = [];
  defaultImage = '../assets/images/portrait/small/default.png';
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private alertService: AlertService,
    private authService: AuthService,
    private renderer: Renderer2
  ) {
  }

  ngOnInit() {
    this.validationForm = this.formBuilder.group({
      email: [this.activeRoute.snapshot.queryParamMap.get('m'), Validators.required],
      code: [this.activeRoute.snapshot.queryParamMap.get('c'), [Validators.required]]
    });
    this.renderer.addClass(document.body, 'authentication-pages');
  }

  ngAfterViewInit(): void {
    const footerElement = document.getElementsByClassName('footer');
    Array.from(footerElement).forEach((el) => {
      this.renderer.removeClass(el, 'footer-static');
      this.renderer.addClass(el, 'fixed-bottom');
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.validationForm.controls;
  }

  tryValidate() {
    this.submitted = true;
    if (this.validationForm.invalid) {
      return;
    }
    this.loading = true;


    this.authService.doValidate(this.validationForm.value).then(
      res => {
        this.alertService.success(res.message, true);

        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 3000);
      },
      err => {
        console.log(err);
        this.loading = false;
        if(err.status==400)
          this.alertService.error(err.error.error ? err.error.error : err.error.message);
        else
          this.alertService.error(err.message);
      }
    );
  }
}
